interface Filters {
  aggregationFilter?: {
    // eslint-disable-next-line camelcase
    product_category_id_list?: string[];
  };
}

export default function normalizeFilters(filters: Filters) {
  const categoryIds = filters.aggregationFilter?.product_category_id_list;

  if (!categoryIds) {
    return filters;
  }

  return {
    ...filters,
    aggregationFilter: {
      ...filters.aggregationFilter,
      // ['1611', '1931-1608', '1610', '1611,1931']
      // => ['1608', '1610', '1611', '1931']
      product_category_id_list: Array.from(
        new Set(categoryIds.flatMap(id => id.split(/[,-]/)))
      ).sort(),
    },
  };
}
